import { accordion } from '../accordion/accordion';

export function init() {
	const filters = Array.from(document.querySelectorAll('.js-filters'));

	filters.forEach(e => {
		const inst = accordion(e.id, {
			activeHeaderClass: 'is-active',
			activePanelClass: 'is-active',
		});

		if (inst) {
			inst.init();
		}
	});
}
